import * as QUESTION_TYPES from '../constants/question_types';
import { isAnswered } from './answer_helper';

type Question = { id: number | string; type: string };
type Answer = { value?: unknown; comment?: string | null };

// The dropdown component emits a single choice id while multiple choice emits an array of ids.
const toChoiceIds = (value: unknown): number[] => (Array.isArray(value) ? value : [value]).map(Number);

const toAnswerInput = (question: Question, answer: Answer | undefined) => {
  const notDisclosed = !isAnswered(question, answer);
  const base = { surveyElementId: Number(question.id), comment: answer?.comment || null, notDisclosed };

  switch (question.type) {
    case QUESTION_TYPES.RATING:
    case QUESTION_TYPES.ENPS:
    case QUESTION_TYPES.ICONS:
    case QUESTION_TYPES.YES_NO:
      return { ...base, scaleValue: notDisclosed ? null : (answer?.value as number) };
    case QUESTION_TYPES.DROPDOWN:
    case QUESTION_TYPES.MULTIPLE_CHOICE:
      return { ...base, selectedChoiceIds: notDisclosed ? [] : toChoiceIds(answer?.value) };
    case QUESTION_TYPES.TEXT:
      return { ...base, textValue: notDisclosed ? null : (answer?.value as string) };
    default:
      return null;
  }
};

/** Maps the survey's answers onto the answer inputs of one submitOpenSurveyResponse call. */
export const buildOpenSurveyAnswers = (questions: Question[], answers: Record<string, Answer>) =>
  questions
    .filter((question) => question.type !== QUESTION_TYPES.MESSAGE)
    .map((question) => toAnswerInput(question, answers[question.id]))
    .filter((input): input is NonNullable<typeof input> => input !== null);
